import { createContext } from 'react';

type RagFlowIdContextType = number | undefined;

export default createContext<RagFlowIdContextType>(undefined);
